import { useState, useEffect } from 'react';

function useScreenWidth() {
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);

  useEffect(() => {
    const updateWidth = () => setInnerWidth(window.innerWidth);
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, [setInnerWidth]);

  return innerWidth;
}

export default useScreenWidth;
